// Pure helpers of the translations (no React), shared with the unit tests.

/** {name} placeholders. Unknown placeholders stay visible, so a missing value is noticed. */
export function interpolate(template: string, vars: Record<string, string | number> = {}): string {
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match));
}

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatBytes(value: number, language = 'en'): string {
  let amount = value;
  let unit = 0;
  while (amount >= 1024 && unit < UNITS.length - 1) {
    amount /= 1024;
    unit++;
  }
  const digits = unit === 0 || amount >= 100 ? 0 : 1;
  return `${new Intl.NumberFormat(language, { maximumFractionDigits: digits }).format(amount)} ${UNITS[unit]}`;
}

/** A piece of a text with links in it: plain words, or a link's name and its words. */
export type TextPart = string | { link: string; text: string };

/**
 * A translated sentence with links in it (TF-388): "I accept the {terms}Terms of service{/terms}."
 * Each language words the whole sentence, so a link takes the grammar around it and its punctuation
 * stays beside it. Plain text before, between and after; an unclosed tag stays visible as text.
 */
export function linkParts(text: string): TextPart[] {
  const parts: TextPart[] = [];
  const pattern = /\{(\w+)\}(.*?)\{\/\1\}/g;
  let at = 0;
  for (const match of text.matchAll(pattern)) {
    if (match.index > at) parts.push(text.slice(at, match.index));
    parts.push({ link: match[1]!, text: match[2]! });
    at = match.index + match[0].length;
  }
  if (at < text.length) parts.push(text.slice(at));
  return parts;
}
